// https://developers.facebook.com/docs/instagram-api/reference/ig-media/
export enum FacebookApiMediaType {
    CAROUSEL_ALBUM = 'CAROUSEL_ALBUM',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}
